module.exports = __webpack_public_path__ + "img/vector.afb209ce.svg";